import React, { ReactElement } from 'react';
import { Badge } from 'elmo-elements';
import { AiSparkleIcon } from '@/components/Icons';
import './AiPoweredBadge.scss';

interface AiPoweredBadgeProps {
  className?: string;
}

const AiPoweredBadge = ({ className }: AiPoweredBadgeProps): ReactElement => (
  <Badge
    type="info"
    role="status"
    className={['ai-powered-badge', className].filter(Boolean).join(' ')}
    icon={<AiSparkleIcon size="xs" />}
  >
    AI-Powered
  </Badge>
);

export default AiPoweredBadge;
